module.exports = __webpack_public_path__ + "static/img/areaA-10.0b1f8ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-10.png
// module id = 930
// module chunks = 1